/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Btn_CheckingInputs */

const en_rd_btn_checking = /** @type {(inputs: Rd_Btn_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading the repo…`)
};

const id_rd_btn_checking = /** @type {(inputs: Rd_Btn_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membaca repo…`)
};

/**
* | output |
* | --- |
* | "Reading the repo…" |
*
* @param {Rd_Btn_CheckingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_btn_checking = /** @type {((inputs?: Rd_Btn_CheckingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Btn_CheckingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_btn_checking(inputs)
	return en_rd_btn_checking(inputs)
});